import { Component, Input, Output, EventEmitter, AfterViewChecked, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'conichi-text',
  templateUrl: './text.html'
})

export class ConichiTextComponent implements AfterViewChecked {
  public controlType: string;
  public position: number;

  @Output() modelChange = new EventEmitter();
  @Input() placeholder: string;
  @Input() type: string;
  @Input() model: string;

  constructor(private cd: ChangeDetectorRef) {}

  ngAfterViewChecked() {
    if (!this.type) this.type = 'text';
    if (this.type === 'password') this.controlType = 'password';
    this.cd.detectChanges();
  }

  showPassword() {
    if (this.type === 'text') { this.type = 'password'; }
    else if (this.type === 'password') { this.type = 'text'; }
  }

  emit(event) {
    this.modelChange.emit(this.model);
  }
}
